<template>
  <div class="flex flex-col gap-5 pt-12.25 md:pt-15 lg:pt-25">
    <div>
      <DemoHeading
        :text="useTerms.heading"
        class="mb-5 sm:ltr:text-2xl md:text-3xl xl:ltr:text-4.5xl xl:ltr:leading-60"
      />
    </div>
    <Terms :use-term="useTerms.description" />
  </div>
</template>

<script>
import DemoHeading from '@components/home-page/DemoSectionHeading.vue'
import Terms from '@src/components/misc/Terms.vue'
export default {
  components: {
    Terms,
    DemoHeading,
  },
  props: {
    useTerms: { type: String, default: '' },
  },
  data() {
    return {}
  },
}
</script>
